module.exports = function() {
  return new Worker(__webpack_public_path__ + "840de86cd7eee665609c.worker.js");
};